export enum EWalletTypeEnum {
  Momo = 'momo',
  ViettelPay = 'viettelpay',
}

export enum DepositMethodEnum {
  FastPay = 'fastpay',
  IBanking = 'ibanking',
  PhoneCard = 'phone_card',
  Crypto = 'crypto',
  EWallet = 'ewallet',
  ATM = 'atm',
  Banking = 'banking',
  CryptoPay = 'cryptopay',
  SmartPay = 'smartpay',
  Paywin = 'paywin',
  ViettelPay = 'viettelpay',
  Momo = 'momo',
  Nicepay = 'nicepay',
  BankAccount = 'bank_account',
}

export enum WithdrawMethodEnum {
  Crypto = 'withdraw_crypto'
}

export enum TransactionStatusEnum {
  FINISHED = 'FINISHED',
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  PENDING = 'PENDING',
  CC_PENDING = 'CC_PENDING',
  PROCESSING = 'PROCESSING',
  CC_PROCESSING = 'CC_PROCESSING',
  SMART_PAY_PROCESSING = 'SMART_PAY_PROCESSING',
  PHONE_CARD_PROCESSING = 'PHONE_CARD_PROCESSING',
  MOMO_PROCESSING = 'MOMO_PROCESSING',
  APPROVED = 'APPROVED',
}
